import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Body } from 'js/design_system/Body';
import { currentUser } from 'js/utils/user';
import ChevronRightIcon from 'js/svg/colorless/chevron_right.svg';

const Button = styled.div`
  @import 'stylesheets/design_system/color';

  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #91919e;
  background-color: $ds-white;
  border: 1px solid $ds-gray-light;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 0.1);
`;

const Text = styled(Body)`
  color: #535366;
`;

const Container = styled.a`
  height: 216px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px;
  background: #f8f8fb;
  border-radius: 4px;
  border: 1px solid $ds-gray-light;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);

  &:hover {
    ${Button} {
      color: $ds-gray-dark;
    }

    ${Text} {
      text-decoration: underline;
    }
  }
`;

export const ViewAllSuggestions: React.FC = () => {
  return (
    <Container
      href={routes.network_new_profile_url({
        page_name: currentUser?.page_name,
        subdomain: currentUser?.domain_name,
        tab: 'suggested',
      })}
    >
      <Button>
        <ChevronRightIcon size={20} />
      </Button>
      <Text size="sm" bold>
        View all suggestions
      </Text>
    </Container>
  );
};
